import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAWfJ_j0Ms7HRIzp-U58PXNwIqJ2myXdlA",
  authDomain: "service-provider-6817e.firebaseapp.com",
  projectId: "service-provider-6817e",
  storageBucket: "service-provider-6817e.firebasestorage.app",
  messagingSenderId: "438192493837",
  appId: "1:438192493837:web:769d18841b1099739b4c44",
  measurementId: "G-51WD78XJ5H",
};

const app = initializeApp(firebaseConfig);

// 👇 Add this line — this is what your token function needs
export const messaging = getMessaging(app);
export const db = getFirestore(app);

export default app;
